function StrongPasswordValidation({ f, exceptionCode }) {
  const errorTypes = {
    MinLength: "MinLength",
    "MissingA-Z": "MissingA-Z",
    "Missinga-z": "Missinga-z",
    "Missing0-9": "Missing0-9",
    MissingSpecSymbols: "MissingSpecSymbols",
    OnlyLatin: "OnlyLatin",
  };

  return (
    <div className=" mt-3 mx-auto">
      {Boolean(exceptionCode) &&
        exceptionCode?.length > 0 &&
        exceptionCode?.map((x) => {
          const foundError = errorTypes?.[x];
          return (
            <div className="error-text-style  mx-auto mt-3">
              {" "}
              {f(`${foundError}`)}
            </div>
          );
        })}
    </div>
  );
}

export default StrongPasswordValidation;
